export enum InitActionsType {
  SELECTED_LINE = 'init/selectedLine',
  SELECTED_LINE_REQUEST = 'init/selectedLineRequest',
  SELECTED_LINE_SUCCESS = 'init/selectedLineSuccess',
  SELECTED_LINE_ERROR = 'init/selectedLineError',
}
